import _ from 'lodash';
export var FIELD_TYPE;
(function (FIELD_TYPE) {
    FIELD_TYPE["DATE"] = "DATE";
    FIELD_TYPE["NUM"] = "NUM";
    FIELD_TYPE["LAYER"] = "LAYER";
    FIELD_TYPE["URL"] = "URL";
    FIELD_TYPE["OPTION"] = "OPTION";
    FIELD_TYPE["STRING"] = "STRING";
})(FIELD_TYPE || (FIELD_TYPE = {}));
export var FIELD_MAIN_TYPE;
(function (FIELD_MAIN_TYPE) {
    FIELD_MAIN_TYPE["PUBLIC"] = "public";
    FIELD_MAIN_TYPE["SELF"] = "self";
    FIELD_MAIN_TYPE["SHARED"] = "shared";
})(FIELD_MAIN_TYPE || (FIELD_MAIN_TYPE = {}));
export const FIELD_MAIN_TYPE_LIST = [
    FIELD_MAIN_TYPE.SHARED,
    FIELD_MAIN_TYPE.PUBLIC,
    FIELD_MAIN_TYPE.SELF,
];
export class CustomFieldLabelController {
    constructor({ vm, workspaceProductDomain }) {
        this.workspaceProductDomain = '';
        this.fields = [];
        this.fieldValueMap = {};
        this.fieldValueMapBak = {};
        this.spaceScopeFieldTip = '';
        this.tabExpandStatus = {};
        this.fieldFilterString = '';
        /** 置顶字段 */
        this.pinFieldsKeys = [];
        /** 标引字段 */
        this.labelingFieldMap = {};
        this.showSpaceScopeDisableTip = (field) => {
            return !this.vm.spaceId && !this.hasLabelFieldPermission(field) && this.fieldLabelScopeIsSpace(field);
        };
        this.vm = vm;
        this.workspaceProductDomain = workspaceProductDomain;
        _.forEach(FIELD_MAIN_TYPE_LIST, (type) => {
            this.tabExpandStatus[type] = false;
        });
    }
    // 允许外界 Overwrite
    get customCustomFieldEditorComponent() {
        return undefined;
    }
    // 允许外界 Overwrite
    getCustomCustomFieldEditorService(field) {
        return undefined;
    }
    // 允许外界 Overwrite
    openCustomCustomFieldEditor(p) {
        throw new Error('openCustomFieldEditor is not implemented');
    }
    fieldLabelScopeIsSpace(field) {
        return field.field_label_scope === 'SPACE';
    }
    updateFieldValueMap(fieldValueMap) {
        this.fieldValueMap = fieldValueMap;
        this.fieldValueMapBak = _.cloneDeep(fieldValueMap);
    }
    updateFieldValue(fieldId, value) {
        this.vm.$set(this.fieldValueMap, 'fieldId', value);
        this.vm.$set(this.fieldValueMapBak, 'fieldId', value);
    }
    getField(fieldId) {
        return _.find(this.fields, { field_id: fieldId });
    }
    expandAll() {
        _.forEach(FIELD_MAIN_TYPE_LIST, (type) => {
            this.tabExpandStatus[type] = true;
        });
    }
    toggleTabExpandStatus(type) {
        this.tabExpandStatus[type] = !this.tabExpandStatus[type];
    }
    fieldFilterMethod(field) {
        const fieldName = (field.field_name || '').toLowerCase();
        const fieldFilterString = (this.fieldFilterString || '').toLowerCase();
        return fieldName.indexOf(fieldFilterString) > -1;
    }
    get displayFieldGroups() {
        const group = _.groupBy(this.fields, (field) => {
            return this.getFieldMainType(field);
        });
        const groups = [];
        _.forEach(_.filter(FIELD_MAIN_TYPE_LIST, (type) => this.isFieldMainTypeSupported(type)), (type) => {
            let fields = group[type] || [];
            fields = _.sortBy(fields, ({ field_id }) => {
                let pinIndex = _.indexOf(this.pinFieldsKeys, field_id);
                if (pinIndex > -1) {
                    return 0 - 10000 - (this.pinFieldsKeys.length - pinIndex);
                }
                return _.findIndex(this.fields, { field_id });
            });
            if (this.fieldFilterString) {
                fields = _.filter(fields, (field) => {
                    return this.fieldFilterMethod(field);
                });
            }
            groups.push({
                type,
                fields,
            });
        });
        return this.handleGroupItems(groups);
    }
    get fieldFilterCount() {
        return _.sumBy(this.displayFieldGroups, ({ fields }) => fields.length || 0);
    }
    isFieldPinned(fieldId) {
        return _.includes(this.pinFieldsKeys, fieldId);
    }
    pinField(fieldId) {
        this.pinFieldsKeys.unshift(fieldId);
    }
    unPinField(fieldId) {
        const index = _.indexOf(this.pinFieldsKeys, fieldId);
        if (index > -1) {
            this.pinFieldsKeys.splice(index, 1);
        }
    }
    toggleFieldPin(fieldId) {
        if (this.isFieldPinned(fieldId)) {
            this.unPinField(fieldId);
        }
        else {
            this.pinField(fieldId);
        }
    }
    isLabelingField(fieldId) {
        return this.labelingFieldMap[fieldId];
    }
    startLabelingField(fieldId) {
        const field = this.getField(fieldId);
        if (this.hasLabelFieldPermission(field)) {
            this.vm.$set(this.labelingFieldMap, fieldId, true);
        }
    }
    endLabelingField(fieldId) {
        this.vm.$set(this.labelingFieldMap, fieldId, false);
    }
    onUpdateFieldValue({ fieldId, value, field: rawField }) {
        if (_.isEqual(value, this.fieldValueMap[fieldId]) || (_.isEmpty(value) && _.isEmpty(this.fieldValueMap[fieldId]))) {
            console.info(`字段 ${fieldId} 数据未发生变化，不发送请求`);
            return Promise.resolve();
        }
        this.fieldValueMap[fieldId] = value;
        const field = this.getField(fieldId);
        return this.onLabelFieldSubmit({ fieldId, value, field: rawField })
            .then((resValue) => {
            console.info(`字段 ${fieldId} 更新成功 ==> ${value}`, field, this);
            this.updateFieldValue(fieldId, resValue);
        })
            .catch(() => {
            console.info(`字段 ${fieldId} 更新失败 ==> 回退至 ${this.fieldValueMapBak[fieldId]}`, field, this);
            this.fieldValueMap[fieldId] = this.fieldValueMapBak[fieldId];
        });
    }
    generateWorkspaceLink(type) {
        return `${this.workspaceProductDomain}/customField?fieldMainType=${type}`;
    }
    // 获取语言，用于日期的格式化;
    getLocale() {
        var _a;
        return ((_a = this.vm.$i18n) === null || _a === void 0 ? void 0 : _a.locale) || 'en';
    }
    // 如果为false，则不显示该类型的字段;
    isFieldMainTypeSupported(type) {
        return true;
    }
    // 是否支持置顶字段;
    isPinSupported(field) {
        return true;
    }
    // 是否有创建字段的权限，如果有，无数据时会显示创建按钮;
    hasManageFieldPermission(type) {
        return false;
    }
    // 是否有标引权限，如果无，则点击标引值不会进入编辑状态;
    hasLabelFieldPermission(field) {
        return field.edit_value;
    }
    // 用于把字段列表分成不同的组;
    getFieldMainType(field) {
        const { public_field, shared, } = field;
        if (public_field) {
            return FIELD_MAIN_TYPE.PUBLIC;
        }
        if (shared) {
            return FIELD_MAIN_TYPE.SHARED;
        }
        return FIELD_MAIN_TYPE.SELF;
    }
    // 是否显示分组头部;
    isShowFieldGroupHeader(type) {
        return true;
    }
    // 生成Group无数据的提示文案;
    generateFieldGroupEmptyText(type) {
        if (this.fieldFilterString) {
            return this.vm.$t('PtCustomFieldLabelPane.filter.noFilterData');
        }
        else if (this.hasManageFieldPermission(type)) {
            return this.vm.$t('PtCustomFieldLabelPane.filter.noDataToCreate', { href: this.generateWorkspaceLink(type) });
        }
        return this.vm.$t('PtCustomFieldLabelPane.filter.noData');
    }
    // 标引值请求发送方法，需要外层实现;
    onLabelFieldSubmit({ fieldId, value, field }) {
        console.warn('请继承此方法，发送更新标引值的请求');
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (Math.random() > -1) {
                    resolve(value);
                }
                else {
                    reject();
                }
            }, 500);
        });
    }
    // 可以在此方法中对分组进行处理;
    handleGroupItems(groups) {
        return groups;
    }
    // 点击AI Check Icon操作
    onClickAICheckIcon(field) {
        console.warn('请继承此方法，发送确认AI标引的请求');
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (Math.random() > -1) {
                    resolve(field);
                }
                else {
                    reject();
                }
            }, 500);
        });
    }
}
